import React from "react";

const Subscriptiontab = () => {
    return(
        <div>
            <p>Subscription tab</p>
        </div>
    )
}

export default Subscriptiontab;